import { useClientTranslation } from '@/lib/core/i18n';
import type { WhereToSheetProps } from '../types';
import { LocationPicker } from './locationPicker';

export function WhereToSheet({ isOpen, onClose, cmsProps, booking, onBookingChange }: WhereToSheetProps) {
  const t = useClientTranslation();

  return (
    <LocationPicker
      isOpen={isOpen}
      onClose={onClose}
      title={cmsProps?.title ?? t('App.Labels.WhereTo')}
      subtitle={cmsProps?.subtitle}
      pickupPoint={booking.pickupPoint}
      dropoffPoint={booking.dropoffPoint}
      target="dropoff"
      onSelect={point => {
        onBookingChange({ dropoffPoint: point });
        onClose();
      }}
    />
  );
}
